<template>
    <div class="countdown-aligner">
        <div class="countdown">
            <img
                class="hypers"
                src="@/assets/custom/maddy/images/hypers.png"
                alt=""
                :style="hypersHello"
            />

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635 101" v-bind:svg-inline="''" v-bind:class="'waves waves--top'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="waves" d="M609.27 5C599.1-1 572-4.13 536 10.73c-11.92 4.92-28.77 16.83-48.21 21.47s-35.08 1.8-50.22.62C387.09 28.87 364.75 55.14 320.43 60 258.21 66.87 229 32 161.1 31.58c-16.07-.1-28 3-44 2.82-31.25-.31-54.11-4.87-86.76 3.36C11.52 42.49.44 46.6 0 50.32c-3.47 31.47 340.84 64.75 527 44.49 61.6-6.7 100.93-18.64 107.1-42.21 4.43-16.78-8.43-37.86-24.83-47.6z"/></svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635 101" v-bind:svg-inline="''" v-bind:class="'waves waves--dark'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="waves" d="M609.27 5C599.1-1 572-4.13 536 10.73c-11.92 4.92-28.77 16.83-48.21 21.47s-35.08 1.8-50.22.62C387.09 28.87 364.75 55.14 320.43 60 258.21 66.87 229 32 161.1 31.58c-16.07-.1-28 3-44 2.82-31.25-.31-54.11-4.87-86.76 3.36C11.52 42.49.44 46.6 0 50.32c-3.47 31.47 340.84 64.75 527 44.49 61.6-6.7 100.93-18.64 107.1-42.21 4.43-16.78-8.43-37.86-24.83-47.6z"/></svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635 101" v-bind:svg-inline="''" v-bind:class="'waves waves--light'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="waves" d="M609.27 5C599.1-1 572-4.13 536 10.73c-11.92 4.92-28.77 16.83-48.21 21.47s-35.08 1.8-50.22.62C387.09 28.87 364.75 55.14 320.43 60 258.21 66.87 229 32 161.1 31.58c-16.07-.1-28 3-44 2.82-31.25-.31-54.11-4.87-86.76 3.36C11.52 42.49.44 46.6 0 50.32c-3.47 31.47 340.84 64.75 527 44.49 61.6-6.7 100.93-18.64 107.1-42.21 4.43-16.78-8.43-37.86-24.83-47.6z"/></svg>
            <span class="title" v-if="!isLive">ArtByMaddy.com opens in</span>
            <span class="title" v-else>Lush Series Available now!</span>
            <div class="clock" v-if="!isLive">
                <span class="hours">{{ hours | doubleDigits }}:</span>
                <span class="minutes">{{ minutes | doubleDigits }}:</span>
                <span class="seconds">{{ seconds | doubleDigits }}</span>
            </div>
            <div class="final" v-else>
                <span>artbymaddy.com</span>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/custom/maddy/typography.scss";
export default {
    name: "maddyCountdown",
    data: function() {
        return {
            timestamp: new Date("Dec 3, 2019 17:30:00").getTime(),
            distance: undefined,
        };
    },
    mounted() {
        const self = this;
        self.updateTime();
        setInterval(function() {
            self.updateTime();
        }, 1000);
    },
    methods: {
        updateTime() {
            const now = new Date().getTime();
            this.distance = this.timestamp - now;
        },
    },
    filters: {
        doubleDigits(val) {
            return (val < 10 ? "0" : "") + val;
        },
    },
    computed: {
        hypersHello() {
            let transformY = this.distance / 10000;

            if (transformY <= 0) transformY = 0;

            return `transform: translateY(${transformY}%)`;
        },
        isLive() {
            return this.distance <= 0;
        },
        hours() {
            const hours = Math.floor(
                (this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
            );
            return hours;
        },
        minutes() {
            const minutes = Math.floor(
                (this.distance % (1000 * 60 * 60)) / (1000 * 60),
            );
            return minutes;
        },
        seconds() {
            const seconds = Math.floor((this.distance % (1000 * 60)) / 1000);
            return seconds;
        },
    },
};
</script>

<style lang="scss" scoped>
.waves {
    position: absolute;
    z-index: 10;
    width: 800px;
    transition: fill 1s ease-in-out;

    &--top {
        fill: #5bf4e4;
        transform: rotate(180deg) translateY(75%) translateX(50%);
    }

    &--light {
        fill: #5bf4e4;
        transform: translateY(50%) translateX(-40%);
    }

    &--dark {
        fill: #26d4c2;
        transform: translateY(40%) translateX(-40%);
    }
}

.hypers {
    align-self: center;
    position: absolute;
    bottom: 12px;
    right: 3px;
    transform: translateY(100%);
    transition: all 1s linear;
    z-index: 5;
    width: 80px;
}

.countdown {
    font-family: "open sans", sans-serif;
    display: inline-flex;
    border-radius: 16px 0 0 8px;
    flex-direction: column;
    align-self: baseline;
    background: white;
    color: #293641;
    padding: 32px 64px;
    overflow: hidden;
    position: relative;
    z-index: 15;
    height: 150px;
    box-sizing: border-box;

    .title {
        font-weight: bold;
        text-transform: uppercase;
    }

    .clock {
        font-size: 48px;
        font-weight: bold;
        font-variant-numeric: tabular-nums;
    }

    .final {
        font-size: 26px;
        font-weight: bold;
    }

    &-aligner {
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: flex-end;
    }
}
</style>
